<template>
  <div>
    <v-layout
      fill-height
      align-center
    >
      <h2 class="subheading font-weight-bold">
        Проработанные варианты
      </h2>
      <v-spacer />
      <v-btn
        color="primary"
        small
        :disabled="!canAdd"
        icon
        @click="variantDialog = true"
      >
        <v-icon>add</v-icon>
      </v-btn>
    </v-layout>
    <div class="pa-1 worked-variant-table">
      <v-data-table
        :items="variants"
        expand
        hide-actions
        :headers-length="3"
        hide-headers
      >
        <template
          slot="items"
          slot-scope="props"
        >
          <tr @click="props.expanded = !props.expanded">
            <td>{{ props.item.title }}</td>
            <td>{{ props.item.content | cropText(30) }}</td>
            <td>
              <v-layout>
                <v-btn
                  class="ma-0"
                  icon
                  small
                  @click="editVariant(props.item.id)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn
                  class="ma-0"
                  icon
                  small
                  @click="deleteVariant(props.item.id)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-layout>
            </td>
          </tr>
        </template>
        <template
          slot="expand"
          slot-scope="props"
        >
          <v-card
            color="grey lighten-2"
            flat
          >
            <v-card-text>{{ props.item.content }}</v-card-text>
          </v-card>
        </template>
      </v-data-table>
    </div>
    <v-layout>
      <v-dialog
        v-model="variantDialog"
        persistent
        width="500"
      >
        <v-card>
          <v-card-text>
            <v-form>
              <v-text-field
                v-model="variantTitle"
                label="Вариант"
                :rules="[rules.required]"
              />
              <v-textarea
                v-model="variantContent"
                label="Комментарий"
                :rules="[rules.required]"
              />

              <v-btn
                small
                color="primary"
                @click="addVariant"
              >
                Ок
              </v-btn>
              <v-btn
                small
                @click="closeVariantDialog"
              >
                Отмена
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import {
  deleteProcessedVariant,
  updateProcessedVariant,
  createProcessedVariant,
} from "../../../backend/shipmentRequestsApi.js";

export default {
  props: ["id", "items", "disabled"],
  data() {
    return {
      editVariantId: 0,
      variantDialog: false,
      variantContent: "",
      variantTitle: "",
      rules: {
        required: value => !!value || "Поле обязательно к заполнению.",
      },
    };
  },
  computed: {
    variants() {
      return this.items;
    },
    canAdd() {
      return !this.disabled;
    },
  },
  methods: {
    editVariant(id) {
      const variant = this.variants.find(v => v.id === id);
      this.editVariantId = id;
      this.variantTitle = variant.title;
      this.variantContent = variant.content;
      this.variantDialog = true;
    },
    closeVariantDialog() {
      this.variantDialog = false;
      this.editVariantId = 0;
      this.variantTitle = "";
      this.variantContent = "";
    },
    async deleteVariant(variantId) {
      await deleteProcessedVariant(this.id, variantId);
      this.$emit("delete");
    },
    async addVariant() {
      if (this.editVariantId !== 0) {
        await updateProcessedVariant(
          this.id,
          this.editVariantId,
          this.variantTitle,
          this.variantContent,
        );
        this.clearDialogVariable();
        this.$emit("update");
      } else {
        await createProcessedVariant(
          this.id,
          this.variantTitle,
          this.variantContent,
        );
        this.clearDialogVariable();
        this.$emit("add");
      }
    },
    clearDialogVariable() {
      this.variantDialog = false;
      this.editVariantId = 0;
      this.variantTitle = "";
      this.variantContent = "";
    },
  },
};
</script>
